import styled from "styled-components";
import React, {JSX, LazyExoticComponent, ReactElement, ReactNode} from "react";
import IconType from "../../assets/icons";

export interface MessageStyleProps {
    $bgColor?: string;
    $textColor?: string;
    $titleColor?: string;
    $status: "successful" | "failed" | "default";
    icon?: string | JSX.Element | LazyExoticComponent<React.FC<IconType>> | ReactElement
    iconClassName?: string
    action?: ReactNode,
    title?: string | JSX.Element | ReactElement
    message: string | JSX.Element | ReactElement
}

export const MessageStyle = styled.div<MessageStyleProps>`
    width: 100%;
    padding: 10px 20px;
    border-radius: 12px;
    display: flex;
    flex-wrap: wrap;
    flex-basis: calc(1px * (100 / 3));
    gap: 10px;
    align-items: center;
    border: 2px dashed ${(props) => props.$status === "successful" ? "#00BD59" : props.$status === "failed" ? "#BD0003" : "#E27D00"};
    background: ${(props) => props.$status === "successful" ? "#D0FED2" : props.$status === "failed" ? "#EB2B0B33" : "#FEEAD0"};

    .title {
        font-weight: 600;
        color: ${(props) => props.$titleColor || props.$status === "successful" ? "#00BD59" : props.$status === "failed" ? "#BD0003" : "#E27D00"};
        flex: 100%;
    }

    .icon,
    .icon svg,
    .icon img {
        font-size: 1.2em !important;
    }

    span.message {
        font-size: var(--step--1);
        font-weight: 600;
        color: black;
        line-height: 20px;
    }

    .action {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        .rb-button {
            font-weight: 400;
            padding: 10px 15px;
            text-wrap: nowrap;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        span.message {
            font-size: var(--step--1);
            font-weight: 500;
            color: black;
            line-height: 20px;
        }
        .action > .rb-button{
            flex: 0 0 100%;
        }
    }
`